<template>

  <section class="section-product-detail-page bg-grey">
    <div class="container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content py-0">
            <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">Automotive and E-mobility</h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
              title="Automotive and E-mobility"
              image-url="/pages/products/industries/mobile.jpg"
              :contents="[
              'Automotive has long history in Thailand and now it is transforming to electrification era. Our plastic resins are ready to serve more demanding requirements in every component of the vehicle from battery, autonomous driving, exterior, interior, light weight technology and eco friendly plastics',
            ]"
              is-reverse="true"
              is-white-content="true"
              is-content-small-text="true"
              left-width="45.805%"
              right-width="54.195%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-image-auto-width">
    <div class="container">
      <div class="page-content">

        <ContentsTextWithImage
            title="EV Battery & Electrification"
            image-url="/pages/products/industries/he.jpg"
            :contents="[
            'Modern vehicles are driven by electricity, connectivity, and sustainability. Plastic materials to use are developing to achieve design, functional, safety, and environmental requirements. Our material solutions are offered to meet the needs of manufacturers in this field from very thin eco FR technology, super light weighting, radio frequency transparency, radar absorbing, excellent dielectric, excellent dimension, and stable properties in whether hot, cold, humid, or strong chemical environment. Recycle materials with same properties with its virgin also available. Example of applications that use our products are',
          ]"
            is-reverse="true"
            is-content-small-text="true"
            left-width="43.752%"
            right-width="56.21%"
        />

      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="/th/plastics/industries/automotive-and-e-mobility/ev-battery-components/">
                        <img src="/pages/products/industries/m-charger04.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="/th/plastics/industries/automotive-and-e-mobility/ev-battery-components/"
                                class="card-title f-21">EV
                        Battery components
                      </a>
                      <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/m-charger02.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">EV Charger</a>
                      <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/m-charger03.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Battery cell structure</a>
                      <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/m-charger05.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Battery pack housing</a>
                      <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/mockup.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Battery pack floor</a>
                      <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/mockup.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Busbar</a>
                      <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-show="isEvMoreGalleryShow">

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Connector</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Sealant</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Battery thermal management</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Thermal adhesive</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Motor</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Cooling system</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">EV charger</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Swappable battery for e-bike</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

    </div>

    <section class="section-product-detail-page pt-4">
      <div class="container page-container">
        <div class="content text-center">
          <button
              class="btn btn-link text-primary text-decoration-none f-15 outline-none"
              @click="handleEVLoadMoreClick"
          >
            {{ evLoadMoreButtonText }}
          </button>
        </div>
      </div>
    </section>


  </section>

  <section class="section-product-detail-page bg-white section-image-auto-width">
    <div class="container">
      <div class="page-content">

        <ContentsTextWithImage
            title="ADAS & Sensors"
            image-url="/pages/products/industries/car.jpg"
            :contents="[
            'Not only self-driving car but our cars today are fully equipped with smart sensing system that provides us full connectivity, comfortability, and safety. Our plastic materials are used in these autonomous systems such as',
          ]"
            is-reverse="true"
            left-width="43.752%"
            right-width="56.21%"
        />

      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ads011.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Radar/Lidar systems</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ads02.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Cameras</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ads03.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Blind spot monitoring system</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/mockup.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Parking sensor</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/mockup.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Sensors</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/mockup.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Navigation system</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

  </section>

  <section class="section-product-detail-page bg-white section-image-auto-width">
    <div class="container">
      <div class="page-content">

        <ContentsTextWithImage
            title="Interior"
            image-url="/pages/products/industries/int.jpg"
            :contents="[
            'Many consumers buy car because of interior designs. Interior designer often selects materials that give last long beautiful surface and colors. At the same time materials should allow manufacturers to produce with cost efficient and ease of processing. Our plastics for car interior are available from soft touch, high gloss, low gloss, metallic, high transparency, and light weighting while still hold good impact strength. More importantly, material must be harmless to passenger health so low VOC or paintless solution are increasingly used. Car interior parts that use our materials are like',
          ]"
            is-reverse="true"
            left-width="43.752%"
            right-width="56.21%"
        />

      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/lin01.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Audio & Infotainment</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/in02.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Tailgate</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/in03.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Door module & Door trim</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/use-cases/car01.jpeg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Instrument panel</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/mockup.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Console</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/mockup.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Room lamp</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-show="isInteriorMoreGalleryShow">
      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Combination switch</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Seat components</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Interior trim</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Shifter components</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Pillars</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="section-product-detail-page pt-4">
      <div class="container page-container">
        <div class="content text-center">
          <button
              class="btn btn-link text-primary text-decoration-none f-15 outline-none"
              @click="handleInteriorLoadMoreClick"
          >
            {{ interiorLoadMoreButtonText }}
          </button>
        </div>
      </div>
    </section>

  </section>

  <section class="section-product-detail-page bg-white section-image-auto-width">
    <div class="container">
      <div class="page-content">

        <ContentsTextWithImage
            title="Exterior"
            image-url="/pages/products/industries/ex.jpg"
            :contents="[
            'Vehicle exterior appearance always draw attention from consumers. But not only give luxurious look our plastic materials used in car exterior also providing high performance and safety of the parts. Exterior is also one of the parts that manufacturer chooses to develop light weighting of the vehicles by replacing metal to plastics in which our materials are available to serve this purpose. Example of exterior components that use our materials.',
          ]"
            is-reverse="true"
            left-width="43.752%"
            right-width="56.21%"
        />

      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ex02.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Door handle</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ex01.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Front grille</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ex03.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Body panel</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/lamp.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Head lamp and rear lamp components</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/side-mirror.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Side mirror</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/tank.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Tank flap</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>


              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-show="isExteriorMoreGalleryShow">
      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Wheel cover</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Bumper</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Exterior trim</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="section-product-detail-page pt-4">
      <div class="container page-container">
        <div class="content text-center">
          <button
              class="btn btn-link text-primary text-decoration-none f-15 outline-none"
              @click="handleExteriorLoadMoreClick"
          >
            {{ exteriorLoadMoreButtonText }}
          </button>
        </div>
      </div>
    </section>

  </section>

  <section class="section-product-detail-page bg-white section-image-auto-width">
    <div class="container">
      <div class="page-content">

        <ContentsTextWithImage
            title="Under the hood & Powertrain"
            image-url="/pages/products/industries/tech.jpg"
            :contents="[
            'This is the part where your car is moving forward. These components are often exposed to harsh environments from heat from engine, oil and chemicals, loads, wear etc.. Plastics materials to use must contain properties to support various requirements for the highest performance of the car and safety of passengers. These are example of plastic we serve',
          ]"
            is-reverse="true"
            left-width="43.752%"
            right-width="56.21%"
        />

      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/hold01.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Duct</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/hold02.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Fan should</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/air-inlet.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Air inlet</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/a-cooling.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Cooling system</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/a-ign.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Ignition coil</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/a-brake.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Brake booster</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-show="isUnderHoodMoreGalleryShow">
      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Throttle body</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Radiator</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">ABS module</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Windshield washer</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Air filter</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Fuse box</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Ignition coil</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Pumps</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">CVJ boots</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Brake booster</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/pages/products/industries/mockup.jpg" alt="">
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">AC compressor</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="section-product-detail-page pt-4">
      <div class="container page-container">
        <div class="content text-center">
          <button
              class="btn btn-link text-primary text-decoration-none f-15 outline-none"
              @click="handleUnderHoodLoadMoreClick"
          >
            {{ underHoodLoadMoreButtonText }}
          </button>
        </div>
      </div>
    </section>

  </section>

</template>
<script setup lang="ts">
useHead({
  title: 'Automotive and E-mobility - NAGASE THAILAND Engineering Plastics',
})

// Section EV
const isEvMoreGalleryShow = useState<Boolean>('isEvMoreGalleryShow', () => false)
const evLoadMoreButtonText = useState<String>('evLoadMoreButtonText', () => 'Read More')

const handleEVLoadMoreClick = () => {
  isEvMoreGalleryShow.value = !isEvMoreGalleryShow.value
  evLoadMoreButtonText.value = isEvMoreGalleryShow.value ? 'Read Less' : 'Read More'
}


// Section Interior
const isInteriorMoreGalleryShow = useState<Boolean>('isInteriorMoreGalleryShow', () => false)
const interiorLoadMoreButtonText = useState<String>('interiorLoadMoreButtonText', () => 'Read More')

const handleInteriorLoadMoreClick = () => {
  isInteriorMoreGalleryShow.value = !isInteriorMoreGalleryShow.value
  interiorLoadMoreButtonText.value = isInteriorMoreGalleryShow.value ? 'Read Less' : 'Read More'
}

// Section Exterior
const isExteriorMoreGalleryShow = useState<Boolean>('isExteriorMoreGalleryShow', () => false)
const exteriorLoadMoreButtonText = useState<String>('exteriorLoadMoreButtonText', () => 'Read More')

const handleExteriorLoadMoreClick = () => {
  isExteriorMoreGalleryShow.value = !isExteriorMoreGalleryShow.value
  exteriorLoadMoreButtonText.value = isExteriorMoreGalleryShow.value ? 'Read Less' : 'Read More'
}

// Section Under the hood & Powertrain
const isUnderHoodMoreGalleryShow = useState<Boolean>('isUnderHoodMoreGalleryShow', () => false)
const underHoodLoadMoreButtonText = useState<String>('underHoodLoadMoreButtonText', () => 'Read More')

const handleUnderHoodLoadMoreClick = () => {
  isUnderHoodMoreGalleryShow.value = !isUnderHoodMoreGalleryShow.value
  underHoodLoadMoreButtonText.value = isUnderHoodMoreGalleryShow.value ? 'Read Less' : 'Read More'
}
</script>

<style scoped>
.page-title {
  padding-bottom: 85px;
}

.section-gallery {
  padding-top: 60px;
  padding-bottom: 60px;
}

.text-custom {
  font-size: 36.5px !important;
}

.spacing-custom {
  margin-top: -5px !important;
  margin-bottom: 60px !important;
}
</style>
